var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "go-block-footer", staticStyle: { height: "auto" } },
    [
      _c("div", { staticClass: "go-card-info" }, [
        _vm.formModel.countView
          ? _c("span", { staticClass: "go-info-item" }, [
              _c("i", { staticClass: "go-icon-18 go-icon-view" }),
              _vm._v(" "),
              _c("em", { staticClass: "go-text" }, [
                _vm._v(_vm._s(_vm.formModel.countView)),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.formModel.countSubscribe
          ? _c("span", { staticClass: "go-info-item" }, [
              _c("i", { staticClass: "go-icon-18 go-icon-subscribe" }),
              _vm._v(" "),
              _c("em", { staticClass: "go-text" }, [
                _vm._v(_vm._s(_vm.formModel.countSubscribe)),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.formModel.countComment
          ? _c("span", { staticClass: "go-info-item" }, [
              _c("i", { staticClass: "go-icon-18 go-icon-comment" }),
              _vm._v(" "),
              _c("em", { staticClass: "go-text" }, [
                _vm._v(_vm._s(_vm.formModel.countComment)),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "go-btn-area" },
        [
          [
            _vm.isCompanyCard
              ? _c(
                  "button",
                  {
                    class: [
                      "btn go-btn-icon go-btn-subscribe",
                      { active: _vm.formModel.subscribeStatus === "SUBSCRIBE" },
                    ],
                    attrs: {
                      type: "button",
                      "data-toggle": "button",
                      "aria-pressed":
                        _vm.formModel.subscribeStatus !== "UN_SUBSCRIBE",
                      disabled: _vm.isLoadingSubcribe,
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.subscribeToCompany.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        class:
                          _vm.formModel.subscribeStatus === "SUBSCRIBE"
                            ? "go-tooltip-area go-toggle-on"
                            : "go-tooltip-area go-toggle-off",
                        attrs: { "data-toggle": "tooltip", title: "Subscribe" },
                      },
                      [
                        _c("i", {
                          class:
                            _vm.formModel.subscribeStatus === "SUBSCRIBE"
                              ? "go-icon-18 go-icon-subscribe-on"
                              : "go-icon-18 go-icon-subscribe",
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          _vm._v(" "),
          !_vm.isCompanyCard
            ? _c("div", { staticClass: "dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-icon",
                    attrs: {
                      id: "dropDownReportButton" + _vm.formModel.docId,
                      type: "button",
                      "data-toggle": "dropdown",
                    },
                  },
                  [_c("i", { staticClass: "go-icon-20 go-icon-more-dot" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dropdown-menu dropdown-menu-right" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.goover.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "go-icon-18 go-icon-goover" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "go-text" }, [
                          _vm._v("Go Over"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.isCompanyCard
                      ? _c(
                          "button",
                          {
                            staticClass: "dropdown-item",
                            attrs: {
                              type: "button",
                              "data-toggle": "button",
                              "aria-pressed": "false",
                              disabled: _vm.formModel.updatingBookmark,
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.toggleResource.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm.formModel.isBookmarked
                              ? _c("i", {
                                  staticClass: "go-icon-18 go-icon-bookmark-on",
                                })
                              : _c("i", {
                                  staticClass:
                                    "go-icon-18 go-icon-bookmark-line",
                                }),
                            _vm._v(" "),
                            _c("span", { staticClass: "go-text" }, [
                              _vm._v("Bookmark"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: { click: _vm.share },
                      },
                      [
                        _c("i", { staticClass: "go-icon-18 go-icon-share" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "go-text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("companyCard.share")) +
                              "\n            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    !["Resource", "SocialBriefing-Detail"].includes(
                      this.$route.name
                    )
                      ? _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.hideCard },
                          },
                          [
                            _c("i", {
                              staticClass: "go-icon-18 go-icon-hidden",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "go-text" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("companyCard.hide")) +
                                  "\n            "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }